/* MV Sortiment assets/mv-sortiment.rechner.js · Agent T-D · 2026-10-02 · Paket D5 Agent D5 · 2026-10-07 */
/*
  Modul "rechner" (Waechter window.__mvSortiment, Schluessel "rechner"; nur Delegation auf document, Zustand nur im
  DOM). Zwei Rechner teilen sich das Modul:

  v2 - Paket D5 (Agent D5, 07.10.2026), Inhaber zum Block auf pulse-vending.de: "Die machen das Rechner Snippet viel
  besser als wir". Rechenbeispiel "Wie rechnet sich das?" in sections/mv-rechner-teaser.liquid, Wurzel
  [data-mv-rechner2]:
    - Reiter je Standort (role tablist, [data-mv-rechner2-reiter]): Klick oder Pfeiltasten setzen die Voreinstellungen
      des Reiters (Verkaeufe pro Tag, Durchschnittspreis brutto, Verkaufstage im Monat) aus dem JSON-Datenblock
      script[data-mv-rechner2-daten] - einzige Quelle der Zahlen; das Skript selbst nennt keine Werte.
    - Regler und Annahmen ([data-mv-rechner2-feld], Schalter [data-mv-rechner2-ust]) rechnen bei jeder Eingabe neu
      (rechne): Umsatz brutto = Verkaeufe x Preis x Tage; Nettoumsatz = Umsatz / (1 + Mehrwertsteuer im Mittel des
      Sortiments), wenn "Umsatzsteuer abziehen" an ist (Standard; Nachtrag D5); Ueberschuss = Nettoumsatz -
      Wareneinsatz (% vom Nettoumsatz) - (Kartengrundgebuehr + Bruttoumsatz x Kartengebuehr x Kartenanteil) -
      Standortmiete (% vom Nettoumsatz oder fix) - Grundkosten; Monate = Geraetepreis netto / Ueberschuss,
      aufgerundet; ueber MONATE_GRENZE "mehr als fuenf Jahren", bei Ueberschuss <= 0 "bei diesen Annahmen nicht".
    - Kacheln zaehlen in ANIMATION_MS zum neuen Wert (requestAnimationFrame; bei prefers-reduced-motion sofort),
      die Live-Region [data-mv-rechner2-ansage] bekommt nach ANSAGE_MS einen zusammengefassten Satz.
    - Fussnote: Platzhalter [data-mv-rechner2-annahme] bekommen die aktuellen Annahmen (Server-HTML ohne Zahlen).
    - Anfrage-Oeffner [data-mv-rechner2-cta]: data-konfiguration (Kurzfassung) und data-standorttyp fuer die
      Lightbox (snippets/mv-anfrage-modal.liquid), href fuer die Kontaktseite ohne Lightbox.
    - Kalkulator-Link [data-mv-rechner2-kalkulator]: URL-Vertrag preis, verkaeufe, bon, marge (= 100 - Wareneinsatz).
    - Produktseiten: Impacts Ereignis variant:change setzt den Geraetepreis (data-mv-rechner2-geraet), wenn die
      Varianten-ID in data-mv-rechner2-varianten steht.

  v1 - Agent T-D (02.10.2026): Rechenbeispiel der Branchenseiten (sections/mv-branche-empfehlung.liquid,
  Kennzahlen-Kacheln, Wurzel [data-mv-rechner] ohne data-mv-rechner2): Verkaeufe x Bon/1,19 x Marge x Tage
  (Standard 30), Ergebnis in [data-mv-rechner-wert], Link [data-mv-rechner-link] mit verkaeufe, bon, marge.
  Unveraendert bis auf D5: der Variantenpreis (data-mv-rechner-preis, data-mv-rechner-varianten) gehoerte nur zum
  alten Teaser und rechnet jetzt in v2.

  Die reinen Funktionen sind fuer Node-Tests ueber module.exports erreichbar (_tests/sektionen.test.mjs,
  _tests/d5-rechner.test.mjs). Sichtbare Texte stehen in TEXTE, Umlaute als \u-Escapes (Datei bleibt ASCII).
*/
(function () {
  'use strict';

  var VERSION = '2026-10-07.1';

  /* ------------------------------------------------------------------ v1 */

  var TAGE = 30;
  var MWST_FAKTOR = 1.19; /* Bon brutto -> netto, wie der Kalkulator (Umsatz ohne MwSt.) */
  var FELDER = ['verkaeufe', 'bon', 'marge'];

  /* Deutsche und englische Schreibweise lesen: "2,50", "2.5", "1.234,5", "1.234", " 40 % " */
  function zahl(wert) {
    if (typeof wert === 'number') return isFinite(wert) ? wert : NaN;
    if (wert === null || wert === undefined) return NaN;
    var s = String(wert).replace(/[\s\u20ac%]/g, '');
    if (!s) return NaN;
    if (s.indexOf(',') !== -1) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
      s = s.replace(/\./g, '');
    }
    if (!/^\d+(\.\d+)?$/.test(s)) return NaN;
    return parseFloat(s);
  }

  /* Gerundeter Monatsbetrag oder null bei ungueltigen Werten: Verkaeufe x Bon/1,19 x Marge x Tage;
     Marge wird auf 100 % gedeckelt */
  function rohertragMonat(verkaeufe, bon, marge, tage) {
    var v = zahl(verkaeufe);
    var b = zahl(bon);
    var m = zahl(marge);
    var t = (tage === undefined || tage === null || tage === '') ? TAGE : zahl(tage);
    if (!isFinite(v) || !isFinite(b) || !isFinite(m) || !isFinite(t) || t <= 0) return null;
    if (m > 100) m = 100;
    return Math.round(v * (b / MWST_FAKTOR) * (m / 100) * t);
  }

  /* Ganze Euro mit Tausenderpunkt ("1.200"); deterministisch ohne Intl */
  function formatEuro(betrag) {
    if (betrag === null || betrag === undefined || !isFinite(betrag)) return '\u2013';
    var n = Math.round(Math.abs(betrag));
    var text = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return betrag < 0 ? '-' + text : text;
  }

  /* Zahl fuer die URL: Punkt als Dezimaltrenner, hoechstens zwei Nachkommastellen */
  function urlZahl(n) {
    return String(Math.round(n * 100) / 100);
  }

  /* Ziel-URL des Kalkulators; vorhandene preis/verkaeufe/bon/marge-Parameter der Basis werden ersetzt */
  function kalkulatorLink(basis, preis, werte) {
    var ziel = basis || '/pages/automaten-kalkulator';
    var hash = '';
    var h = ziel.indexOf('#');
    if (h !== -1) {
      hash = ziel.slice(h);
      ziel = ziel.slice(0, h);
    }
    var q = ziel.indexOf('?');
    var pfad = q === -1 ? ziel : ziel.slice(0, q);
    var rest = q === -1 ? [] : ziel.slice(q + 1).split('&').filter(function (teil) {
      var name = teil.split('=')[0];
      return teil && name !== 'preis' && FELDER.indexOf(name) === -1;
    });
    var p = zahl(preis);
    if (isFinite(p) && p > 0) rest.push('preis=' + Math.floor(p));
    if (werte) {
      FELDER.forEach(function (feld) {
        var w = zahl(werte[feld]);
        if (isFinite(w)) rest.push(feld + '=' + urlZahl(w));
      });
    }
    return pfad + (rest.length ? '?' + rest.join('&') : '') + hash;
  }

  /* ------------------------------------------------------------------ v2 (Paket D5) */

  var MONATE_GRENZE = 60;   /* ab mehr als 60 Monaten zeigt die Kachel TEXTE.lang */
  var ANIMATION_MS = 350;   /* Zaehlanimation der Kacheln (hoechstens 400 ms) */
  var ANSAGE_MS = 500;      /* Pause, nach der die Live-Region den Satz bekommt */
  var PROZENT_FELDER = ['mwst', 'wareneinsatz', 'karte_prozent', 'kartenanteil', 'miete_prozent'];
  var EURO_FELDER = ['grundkosten', 'karte_fix', 'miete_fix'];
  /* Reihenfolge der Annahmen in der Kurzfassung fuer die Anfrage (die Miete folgt je nach Art) */
  var ANNAHMEN_FELDER = ['wareneinsatz', 'grundkosten', 'karte_fix', 'karte_prozent', 'kartenanteil'];

  var TEXTE = {
    ca: '\u2248',                              /* ungefaehr-gleich-Zeichen */
    nbsp: '\u00a0',
    euro: '\u20ac',
    minus: '\u2212',
    strich: '\u2013',                          /* kein Wert */
    prozent: '%',
    monat: 'Monat',
    monate: 'Monaten',
    lang: 'mehr als f\u00fcnf Jahren',         /* mehr als fuenf Jahren */
    nie: 'bei diesen Annahmen nicht',
    ungefaehr: 'ungef\u00e4hr',                /* ungefaehr (Ansage statt Zeichen) */
    standort: 'Standort',
    nein: 'nein',
    trenner: ' \u00b7 '
  };

  function nichtNegativ(x) {
    var n = zahl(x);
    return isFinite(n) && n >= 0 ? n : NaN;
  }

  function prozentWert(x) {
    var n = nichtNegativ(x);
    return n <= 100 ? n : NaN;
  }

  /* eingaben: { verkaeufe, preis (brutto), tage, geraetPreis (netto) }
     annahmen: { wareneinsatz %, grundkosten EUR, karteFix EUR, karteProzent %, kartenanteil %,
                 miete 'prozent'|'fix', mieteProzent %, mieteFix EUR, ustAbziehen true|false, mwst % (Mittel des Sortiments) }
     Mit ustAbziehen (Nachtrag D5, Hauptsession 07.10.2026: brutto gegen den Nettopreis des Geraets waere
     Schoenfaerberei): Nettoumsatz = Umsatz brutto / (1 + mwst); Wareneinsatz und Standortmiete in % beziehen sich auf
     den Nettoumsatz, die Kartengebuehr in % weiter auf den gezahlten Bruttobetrag. Ohne Abzug ist Netto = Brutto.
     -> { umsatz, netto, umsatzsteuer, ware, karte, miete, grundkosten, ueberschuss, monate, status } oder null bei
     ungueltigen Werten. status: 'ok' | 'lang' (mehr als MONATE_GRENZE) | 'nie' (Ueberschuss <= 0) | 'ohne-preis' */
  function rechne(eingaben, annahmen) {
    var e = eingaben || {};
    var a = annahmen || {};
    var v = nichtNegativ(e.verkaeufe);
    var p = nichtNegativ(e.preis);
    var t = nichtNegativ(e.tage);
    var w = prozentWert(a.wareneinsatz);
    var g = nichtNegativ(a.grundkosten);
    var kf = nichtNegativ(a.karteFix);
    var kp = prozentWert(a.karteProzent);
    var ka = prozentWert(a.kartenanteil);
    var fix = a.miete === 'fix';
    var m = fix ? nichtNegativ(a.mieteFix) : prozentWert(a.mieteProzent);
    var ust = a.ustAbziehen === true || a.ustAbziehen === 'true';
    var satz = ust ? prozentWert(a.mwst) : 0;
    var pruefen = [v, p, t, w, g, kf, kp, ka, m, satz];
    for (var i = 0; i < pruefen.length; i++) {
      if (!isFinite(pruefen[i])) return null;
    }
    var umsatz = v * p * t;
    var netto = ust ? umsatz / (1 + satz / 100) : umsatz;
    var ware = netto * w / 100;
    var karte = kf + umsatz * kp * ka / 10000;
    var miete = fix ? m : netto * m / 100;
    var ueberschuss = netto - ware - karte - miete - g;
    var geraet = nichtNegativ(e.geraetPreis);
    var monate = null;
    var status;
    if (!(ueberschuss > 0)) {
      status = 'nie';
    } else if (!(geraet > 0)) {
      status = 'ohne-preis';
    } else {
      /* aufrunden (vorsichtig); 1e-9 faengt Rundungsfehler bei glatten Quotienten ab */
      monate = Math.ceil(geraet / ueberschuss - 1e-9);
      status = monate > MONATE_GRENZE ? 'lang' : 'ok';
    }
    return { umsatz: umsatz, netto: netto, umsatzsteuer: umsatz - netto, ware: ware, karte: karte, miete: miete, grundkosten: g, ueberschuss: ueberschuss, monate: monate, status: status };
  }

  /* Ganze Euro; nie -0 */
  function runde(betrag) {
    var n = Math.round(betrag);
    return n === 0 ? 0 : n;
  }

  function tausender(text) {
    return text.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* Zahl de-DE: Tausenderpunkt, Dezimalkomma, echtes Minus. stellen = feste Nachkommastellen ("2,20"),
     ohne Angabe hoechstens zwei ohne Endnullen ("2,5", "14"). Ungueltig -> Strich. */
  function zahlText(n, stellen) {
    var x = typeof n === 'number' ? n : zahl(n);
    if (!isFinite(x)) return TEXTE.strich;
    var fest = typeof stellen === 'number' && stellen >= 0;
    var faktor = Math.pow(10, fest ? stellen : 2);
    var r = Math.round(Math.abs(x) * faktor) / faktor;
    var teile = (fest ? r.toFixed(stellen) : String(r)).split('.');
    var text = tausender(teile[0]) + (teile[1] ? ',' + teile[1] : '');
    return x < 0 && r !== 0 ? TEXTE.minus + text : text;
  }

  /* Ganze Euro mit U+00A0 vor dem Eurozeichen */
  function euroText(betrag) {
    var x = typeof betrag === 'number' ? betrag : zahl(betrag);
    if (!isFinite(x)) return TEXTE.strich;
    return zahlText(runde(x)) + TEXTE.nbsp + TEXTE.euro;
  }

  function ca(text) {
    return TEXTE.ca + TEXTE.nbsp + text;
  }

  /* Anzeigetexte der drei Kacheln; monate: { zahl, zusatz (Einheit), text (Textzustand), nach (Beschriftung "nach") } */
  function anzeige(ergebnis) {
    if (!ergebnis) {
      return { umsatz: TEXTE.strich, ueberschuss: TEXTE.strich, monate: { zahl: TEXTE.strich, zusatz: '', text: false, nach: true } };
    }
    var monate;
    if (ergebnis.status === 'ok') {
      monate = { zahl: ca(zahlText(ergebnis.monate)), zusatz: ergebnis.monate === 1 ? TEXTE.monat : TEXTE.monate, text: false, nach: true };
    } else if (ergebnis.status === 'lang') {
      monate = { zahl: TEXTE.lang, zusatz: '', text: true, nach: true };
    } else if (ergebnis.status === 'nie') {
      monate = { zahl: TEXTE.nie, zusatz: '', text: true, nach: false };
    } else {
      monate = { zahl: TEXTE.strich, zusatz: '', text: false, nach: true };
    }
    return { umsatz: ca(euroText(ergebnis.umsatz)), ueberschuss: ca(euroText(ergebnis.ueberschuss)), monate: monate };
  }

  /* Werte fuer kalkulatorLink: bon = Durchschnittspreis brutto, marge = 100 - Wareneinsatz */
  function kalkulatorWerte(eingaben, annahmen) {
    var e = eingaben || {};
    var w = prozentWert((annahmen || {}).wareneinsatz);
    return { verkaeufe: e.verkaeufe, bon: e.preis, marge: isFinite(w) ? 100 - w : undefined };
  }

  /* Kurzfassung fuer data-konfiguration der Lightbox: Teile mit Mittelpunkt (TEXTE.trenner, wie konfigurationsText im
     Konfigurator), Leerraum normalisiert, hoechstens 900 Zeichen (so viel uebernimmt contact[Konfiguration]) */
  function konfigurationText(teile) {
    var liste = [];
    for (var i = 0; i < (teile || []).length; i++) {
      var t = String(teile[i] === null || teile[i] === undefined ? '' : teile[i]).replace(/\s+/g, ' ').trim();
      if (t) liste.push(t);
    }
    return liste.join(TEXTE.trenner).slice(0, 900);
  }

  var api = {
    VERSION: VERSION,
    TAGE: TAGE,
    MWST_FAKTOR: MWST_FAKTOR,
    MONATE_GRENZE: MONATE_GRENZE,
    ANIMATION_MS: ANIMATION_MS,
    ANSAGE_MS: ANSAGE_MS,
    TEXTE: TEXTE,
    zahl: zahl,
    rohertragMonat: rohertragMonat,
    formatEuro: formatEuro,
    kalkulatorLink: kalkulatorLink,
    rechne: rechne,
    runde: runde,
    zahlText: zahlText,
    euroText: euroText,
    anzeige: anzeige,
    kalkulatorWerte: kalkulatorWerte,
    konfigurationText: konfigurationText
  };

  if (typeof module === 'object' && module && module.exports) {
    module.exports = api;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* Waechter (siehe Kopf) */
  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.rechner) return;
  MV.rechner = api;

  /* ------------------------------------------------------------------ DOM v1 (Rechenbeispiel der Branchenseiten) */

  function feld(root, name) {
    return root.querySelector('[data-mv-rechner-feld="' + name + '"]');
  }

  function aktualisiere(root) {
    if (!root || !root.querySelector || root.hasAttribute('data-mv-rechner2')) return;
    var tage = zahl(root.getAttribute('data-mv-rechner-tage'));
    if (!isFinite(tage) || tage <= 0) tage = TAGE;

    var werte = {};
    var gueltig = true;
    FELDER.forEach(function (name) {
      var el = feld(root, name);
      var w = el ? zahl(el.value) : NaN;
      werte[name] = w;
      var ok = isFinite(w);
      if (!ok) gueltig = false;
      if (el) {
        if (ok) el.removeAttribute('aria-invalid');
        else el.setAttribute('aria-invalid', 'true');
      }
    });

    var betrag = gueltig ? rohertragMonat(werte.verkaeufe, werte.bon, werte.marge, tage) : null;
    var ausgabe = root.querySelector('[data-mv-rechner-wert]');
    if (ausgabe) {
      var text = formatEuro(betrag);
      if (ausgabe.textContent !== text) ausgabe.textContent = text;
    }

    var link = root.querySelector('[data-mv-rechner-link]');
    if (link) {
      var basis = link.getAttribute('data-mv-rechner-basis') || '/pages/automaten-kalkulator';
      link.setAttribute('href', kalkulatorLink(basis, null, gueltig ? werte : null));
    }
  }

  function alleAktualisieren(bereich) {
    var wurzel = bereich && bereich.querySelectorAll ? bereich : document;
    var liste = wurzel.querySelectorAll('[data-mv-rechner]');
    for (var i = 0; i < liste.length; i++) aktualisiere(liste[i]);
  }

  function beiEingabe(event) {
    var ziel = event.target;
    if (!ziel || !ziel.closest || !ziel.closest('[data-mv-rechner-feld]')) return;
    aktualisiere(ziel.closest('[data-mv-rechner]'));
  }

  /* ------------------------------------------------------------------ DOM v2 (Rechner-Teaser) */

  var DATEN = typeof WeakMap === 'function' ? new WeakMap() : null;

  /* JSON-Datenblock der Sektion ({ vorwahl, reiter: [{ id, verkaeufe, preis, tage }], annahmen }) oder null */
  function daten(root) {
    if (DATEN && DATEN.has(root)) return DATEN.get(root);
    var el = root.querySelector('script[data-mv-rechner2-daten]');
    var d = null;
    try {
      d = el ? JSON.parse(el.textContent) : null;
    } catch (fehler) {
      d = null;
    }
    if (d && DATEN) DATEN.set(root, d);
    return d;
  }

  function voreinstellung(d, id) {
    var liste = d && d.reiter;
    if (!liste || !liste.length) return null;
    for (var i = 0; i < liste.length; i++) {
      if (liste[i] && liste[i].id === id) return liste[i];
    }
    return null;
  }

  function feld2(root, name) {
    return root.querySelector('[data-mv-rechner2-feld="' + name + '"]');
  }

  function grenze(el, attr) {
    var n = parseFloat(el.getAttribute(attr));
    return isFinite(n) ? n : null;
  }

  /* Wert eines Feldes, auf min/max begrenzt; leer oder ungueltig -> NaN (Feld bekommt aria-invalid) */
  function lies(root, name) {
    var el = feld2(root, name);
    if (!el) return NaN;
    var roh = String(el.value === undefined || el.value === null ? '' : el.value).trim().replace(',', '.');
    var n = roh === '' ? NaN : Number(roh);
    if (isFinite(n)) {
      var min = grenze(el, 'min');
      var max = grenze(el, 'max');
      if (min !== null && n < min) n = min;
      if (max !== null && n > max) n = max;
      el.removeAttribute('aria-invalid');
    } else if (!el.disabled) {
      el.setAttribute('aria-invalid', 'true');
    }
    return n;
  }

  function setze(root, name, wert) {
    var el = feld2(root, name);
    var n = typeof wert === 'number' ? wert : zahl(wert);
    if (el && isFinite(n)) {
      el.value = String(n);
      el.removeAttribute('aria-invalid');
    }
  }

  function mieteArt(root) {
    var r = root.querySelector('[data-mv-rechner2-miete]:checked');
    return r && r.value === 'fix' ? 'fix' : 'prozent';
  }

  /* Schalter "Umsatzsteuer abziehen"; ohne Schalter im Markup gilt der JSON-Datenblock, sonst an */
  function ustAbziehen(root) {
    var schalter = root.querySelector('[data-mv-rechner2-ust]');
    if (schalter) return !!schalter.checked;
    var d = daten(root);
    return !(d && d.annahmen && d.annahmen.ustAbziehen === false);
  }

  function aktiverReiter(root) {
    return root.querySelector('[data-mv-rechner2-reiter][aria-selected="true"]');
  }

  /* Text ohne versteckte Teile (hidden, aria-hidden: Sternchen, "nach" im Textzustand) */
  function rohText(el) {
    var text = '';
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) text += n.nodeValue;
      else if (n.nodeType === 1 && !n.hidden && n.getAttribute('aria-hidden') !== 'true') text += rohText(n);
    }
    return text;
  }

  function sichtbar(el) {
    return el ? rohText(el).replace(/\s+/g, ' ').trim() : '';
  }

  function beschriftung(root, el) {
    if (!el) return '';
    var label = el.id ? root.querySelector('label[for="' + el.id + '"]') : null;
    return ((label ? label.textContent : el.getAttribute('aria-label')) || '').replace(/\s+/g, ' ').trim();
  }

  function ohneBewegung() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (fehler) {
      return false;
    }
  }

  /* Zahl in el anzeigen; mit animieren zaehlt sie in ANIMATION_MS vom angezeigten zum neuen Wert */
  function zeigeZahl(el, ziel, format, animieren) {
    if (!el) return;
    var lauf = el.__mvRechner2 || (el.__mvRechner2 = { wert: NaN, token: 0 });
    lauf.token += 1;
    var start = lauf.wert;
    if (!animieren || !isFinite(start) || start === ziel || ohneBewegung() || typeof window.requestAnimationFrame !== 'function') {
      lauf.wert = ziel;
      el.textContent = format(ziel);
      return;
    }
    var token = lauf.token;
    var anfang = null;
    function schritt(jetzt) {
      if (lauf.token !== token) return;
      if (anfang === null) anfang = jetzt;
      var f = Math.min(1, (jetzt - anfang) / ANIMATION_MS);
      var weg = 1 - Math.pow(1 - f, 3);
      lauf.wert = f < 1 ? start + (ziel - start) * weg : ziel;
      el.textContent = format(lauf.wert);
      if (f < 1) window.requestAnimationFrame(schritt);
    }
    window.requestAnimationFrame(schritt);
  }

  /* Textzustand (Strich, "bei diesen Annahmen nicht" ...): bricht eine laufende Animation ab */
  function zeigeText(el, text) {
    if (!el) return;
    var lauf = el.__mvRechner2 || (el.__mvRechner2 = { wert: NaN, token: 0 });
    lauf.token += 1;
    lauf.wert = NaN;
    el.textContent = text;
  }

  function euroCa(n) {
    return ca(euroText(n));
  }

  function monateCa(n) {
    return ca(zahlText(Math.round(n)));
  }

  function zeigeRegler(root, name, wert, stellen, anzeigeText) {
    var el = feld2(root, name);
    var aus = root.querySelector('[data-mv-rechner2-anzeige="' + name + '"]');
    if (aus) aus.textContent = isFinite(wert) ? anzeigeText : TEXTE.strich;
    if (!el || !isFinite(wert)) return;
    el.setAttribute('aria-valuetext', zahlText(wert, stellen) + ' ' + (el.getAttribute('data-mv-rechner2-einheit') || ''));
    var min = grenze(el, 'min');
    var max = grenze(el, 'max');
    if (min !== null && max !== null && max > min) {
      var anteil = Math.max(0, Math.min(100, (wert - min) / (max - min) * 100));
      el.style.setProperty('--mvs-rechner2-fuellung', anteil.toFixed(2) + '%');
    }
  }

  function annahmeText(name, wert) {
    if (!isFinite(wert)) return TEXTE.strich;
    if (PROZENT_FELDER.indexOf(name) !== -1) return zahlText(wert) + TEXTE.nbsp + TEXTE.prozent;
    if (EURO_FELDER.indexOf(name) !== -1) return zahlText(wert) + TEXTE.nbsp + TEXTE.euro;
    return zahlText(wert);
  }

  /* Liest alle Eingaben, rechnet, zeigt Regler, Kacheln, Fussnote, Geraetepreis, Anfrage und Kalkulator an.
     opts.animieren: Kacheln zaehlen; opts.ansage: Live-Region bekommt nach ANSAGE_MS den Satz */
  function aktualisiere2(root, opts) {
    if (!root || !root.querySelector) return;
    opts = opts || {};
    var art = mieteArt(root);
    var feldProzent = feld2(root, 'miete_prozent');
    var feldFix = feld2(root, 'miete_fix');
    if (feldProzent) feldProzent.disabled = art === 'fix';
    if (feldFix) feldFix.disabled = art !== 'fix';
    var ust = ustAbziehen(root);
    var feldMwst = feld2(root, 'mwst');
    if (feldMwst) feldMwst.disabled = !ust;

    var werte = {};
    ['verkaeufe', 'preis', 'tage', 'mwst'].concat(ANNAHMEN_FELDER, ['miete_prozent', 'miete_fix']).forEach(function (name) {
      werte[name] = lies(root, name);
    });
    var eingaben = { verkaeufe: werte.verkaeufe, preis: werte.preis, tage: werte.tage, geraetPreis: zahl(root.getAttribute('data-mv-rechner2-geraet')) };
    var annahmen = {
      wareneinsatz: werte.wareneinsatz,
      grundkosten: werte.grundkosten,
      karteFix: werte.karte_fix,
      karteProzent: werte.karte_prozent,
      kartenanteil: werte.kartenanteil,
      miete: art,
      mieteProzent: werte.miete_prozent,
      mieteFix: werte.miete_fix,
      ustAbziehen: ust,
      mwst: werte.mwst
    };
    var ergebnis = rechne(eingaben, annahmen);
    var texte = anzeige(ergebnis);

    zeigeRegler(root, 'verkaeufe', werte.verkaeufe, undefined, zahlText(werte.verkaeufe));
    zeigeRegler(root, 'preis', werte.preis, 2, zahlText(werte.preis, 2) + TEXTE.nbsp + TEXTE.euro);

    /* Kacheln */
    var animieren = !!opts.animieren;
    ['umsatz', 'ueberschuss'].forEach(function (name) {
      var wert = root.querySelector('[data-mv-rechner2-wert="' + name + '"]');
      var z = wert ? wert.querySelector('[data-mv-rechner2-zahl]') : null;
      if (ergebnis) zeigeZahl(z, runde(ergebnis[name]), euroCa, animieren);
      else zeigeText(z, TEXTE.strich);
      /* fester Zusatz (Umsatz: "brutto") nur neben einer Zahl */
      var fest = wert ? wert.querySelector('[data-mv-rechner2-zusatz]') : null;
      if (fest) fest.hidden = !ergebnis;
    });
    var monateWert = root.querySelector('[data-mv-rechner2-wert="monate"]');
    if (monateWert) {
      var mz = monateWert.querySelector('[data-mv-rechner2-zahl]');
      var zusatz = monateWert.querySelector('[data-mv-rechner2-zusatz]');
      var m = texte.monate;
      if (ergebnis && ergebnis.status === 'ok') zeigeZahl(mz, ergebnis.monate, monateCa, animieren);
      else zeigeText(mz, m.zahl);
      if (zusatz) {
        zusatz.textContent = m.zusatz;
        zusatz.hidden = !m.zusatz;
      }
      monateWert.classList.toggle('mv-rechner2__wert--text', !!m.text);
      var nach = root.querySelector('[data-mv-rechner2-nach]');
      if (nach) nach.hidden = !m.nach;
    }

    /* Fussnote mit den Annahmen */
    var platz = root.querySelectorAll('[data-mv-rechner2-annahme]');
    for (var i = 0; i < platz.length; i++) {
      var name = platz[i].getAttribute('data-mv-rechner2-annahme');
      platz[i].textContent = annahmeText(name, werte[name]);
    }
    var mieteTexte = root.querySelectorAll('[data-mv-rechner2-miete-text]');
    for (var j = 0; j < mieteTexte.length; j++) mieteTexte[j].hidden = mieteTexte[j].getAttribute('data-mv-rechner2-miete-text') !== art;
    /* Texte mit und ohne Abzug der Umsatzsteuer (Fussnote, Vermerk an der Ueberschuss-Kachel) */
    var ustTexte = root.querySelectorAll('[data-mv-rechner2-ust-text]');
    for (var u = 0; u < ustTexte.length; u++) ustTexte[u].hidden = ustTexte[u].getAttribute('data-mv-rechner2-ust-text') !== (ust ? 'an' : 'aus');
    var fussnote = root.querySelector('[data-mv-rechner2-fussnote]');
    if (fussnote) fussnote.hidden = false;

    var geraetPreis = root.querySelector('[data-mv-rechner2-geraet-preis]');
    if (geraetPreis && isFinite(eingaben.geraetPreis) && eingaben.geraetPreis > 0) geraetPreis.textContent = zahlText(Math.floor(eingaben.geraetPreis));

    /* Kacheln als Saetze: Kurzfassung fuer die Anfrage und Ansage */
    var kacheln = [];
    ['umsatz', 'ueberschuss', 'monate'].forEach(function (name) {
      var wert = root.querySelector('[data-mv-rechner2-wert="' + name + '"]');
      var kachel = wert && wert.parentNode;
      var etikett = kachel ? kachel.querySelector('.mv-rechner2__etikett') : null;
      var zusatzText = wert ? wert.querySelector('[data-mv-rechner2-zusatz]') : null;
      var text = (name === 'monate' ? texte.monate.zahl : texte[name]) + (zusatzText && !zusatzText.hidden && zusatzText.textContent ? ' ' + zusatzText.textContent.trim() : '');
      if (etikett) kacheln.push({ etikett: sichtbar(etikett), text: text });
    });

    var cta = root.querySelector('[data-mv-rechner2-cta]');
    if (cta) {
      var reiter = aktiverReiter(root);
      var typ = reiter ? reiter.getAttribute('data-mv-rechner2-standorttyp') || '' : '';
      var teile = [];
      if (reiter) teile.push(TEXTE.standort + ': ' + sichtbar(reiter));
      teile.push(beschriftung(root, feld2(root, 'verkaeufe')) + ': ' + zahlText(werte.verkaeufe));
      teile.push(beschriftung(root, feld2(root, 'preis')) + ': ' + zahlText(werte.preis, 2) + ' ' + TEXTE.euro);
      teile.push(beschriftung(root, feld2(root, 'tage')) + ': ' + zahlText(werte.tage));
      kacheln.forEach(function (k) { teile.push(k.etikett + ': ' + k.text); });
      if (ust) {
        teile.push(beschriftung(root, feld2(root, 'mwst')) + ': ' + zahlText(werte.mwst));
      } else {
        var schalter = root.querySelector('[data-mv-rechner2-ust]');
        var schalterLabel = schalter && schalter.closest ? schalter.closest('label') : null;
        if (schalterLabel) teile.push(sichtbar(schalterLabel) + ': ' + TEXTE.nein);
      }
      ANNAHMEN_FELDER.concat([art === 'fix' ? 'miete_fix' : 'miete_prozent']).forEach(function (name) {
        teile.push(beschriftung(root, feld2(root, name)) + ': ' + zahlText(werte[name]));
      });
      var konfiguration = konfigurationText(teile);
      var produkt = cta.getAttribute('data-produkt') || '';
      cta.setAttribute('data-konfiguration', konfiguration);
      cta.setAttribute('data-standorttyp', typ);
      var anfrage = cta.getAttribute('data-mv-rechner2-anfrage');
      if (anfrage) {
        cta.setAttribute('href', anfrage + (produkt ? '&produkt=' + encodeURIComponent(produkt) : '') + (typ ? '&standorttyp=' + encodeURIComponent(typ) : '') + '&konfiguration=' + encodeURIComponent(konfiguration));
      }
    }

    var kalkulator = root.querySelector('[data-mv-rechner2-kalkulator]');
    if (kalkulator) {
      kalkulator.setAttribute('href', kalkulatorLink(kalkulator.getAttribute('data-mv-rechner2-basis'), eingaben.geraetPreis, kalkulatorWerte(eingaben, annahmen)));
    }

    if (opts.ansage) {
      var live = root.querySelector('[data-mv-rechner2-ansage]');
      if (live) {
        var satz = kacheln.map(function (k) {
          return k.etikett + ': ' + k.text.split(TEXTE.ca + TEXTE.nbsp).join(TEXTE.ungefaehr + ' ') + '.';
        }).join(' ');
        window.clearTimeout(root.__mvRechner2Ansage);
        root.__mvRechner2Ansage = window.setTimeout(function () {
          live.textContent = satz;
        }, ANSAGE_MS);
      }
    }
  }

  /* Reiter waehlen: aria-selected/tabindex, tabpanel benennen, Voreinstellungen aus dem JSON setzen, neu rechnen
     (opts wie aktualisiere2, Standard: zaehlen und ansagen) */
  function waehleReiter(root, reiter, opts) {
    if (!root || !reiter) return;
    var alle = root.querySelectorAll('[data-mv-rechner2-reiter]');
    for (var i = 0; i < alle.length; i++) {
      var aktiv = alle[i] === reiter;
      alle[i].setAttribute('aria-selected', aktiv ? 'true' : 'false');
      alle[i].setAttribute('tabindex', aktiv ? '0' : '-1');
    }
    var panel = root.querySelector('[data-mv-rechner2-panel]');
    if (panel && reiter.id) panel.setAttribute('aria-labelledby', reiter.id);
    var v = voreinstellung(daten(root), reiter.getAttribute('data-mv-rechner2-reiter'));
    if (v) {
      setze(root, 'verkaeufe', v.verkaeufe);
      setze(root, 'preis', v.preis);
      setze(root, 'tage', v.tage);
    }
    aktualisiere2(root, opts || { animieren: true, ansage: true });
  }

  /* Annahmen auf die Werte der Sektion zuruecksetzen (Verkaufstage: Voreinstellung des aktiven Reiters) */
  function zuruecksetzen(root) {
    var d = daten(root);
    var a = d && d.annahmen;
    if (a) {
      setze(root, 'wareneinsatz', a.wareneinsatz);
      setze(root, 'grundkosten', a.grundkosten);
      setze(root, 'karte_fix', a.karteFix);
      setze(root, 'karte_prozent', a.karteProzent);
      setze(root, 'kartenanteil', a.kartenanteil);
      setze(root, 'miete_prozent', a.mieteProzent);
      setze(root, 'miete_fix', a.mieteFix);
      setze(root, 'mwst', a.mwst);
      var radios = root.querySelectorAll('[data-mv-rechner2-miete]');
      for (var i = 0; i < radios.length; i++) radios[i].checked = radios[i].value === (a.miete === 'fix' ? 'fix' : 'prozent');
      var schalter = root.querySelector('[data-mv-rechner2-ust]');
      if (schalter) schalter.checked = a.ustAbziehen !== false;
    }
    var reiter = aktiverReiter(root);
    var v = reiter ? voreinstellung(d, reiter.getAttribute('data-mv-rechner2-reiter')) : null;
    if (v) setze(root, 'tage', v.tage);
    aktualisiere2(root, { animieren: true, ansage: true });
  }

  /* Erstanzeige: die Werte des vorgewaehlten Reiters stehen schon im Server-HTML; ohne gewaehlten Reiter (z. B.
     fremdes Markup) gilt die Vorwahl aus dem JSON. Keine Ansage beim Laden. */
  function init2(root) {
    if (!root || !root.querySelector) return;
    var zurueck = root.querySelector('[data-mv-rechner2-zuruecksetzen]');
    if (zurueck) zurueck.hidden = false;
    if (!aktiverReiter(root)) {
      var d = daten(root);
      var reiter = (d && d.vorwahl ? root.querySelector('[data-mv-rechner2-reiter="' + d.vorwahl + '"]') : null) || root.querySelector('[data-mv-rechner2-reiter]');
      if (reiter) {
        waehleReiter(root, reiter, { animieren: false, ansage: false });
        return;
      }
    }
    aktualisiere2(root, { animieren: false, ansage: false });
  }

  function alle2(bereich) {
    var wurzel = bereich && bereich.querySelectorAll ? bereich : document;
    var liste = wurzel.querySelectorAll('[data-mv-rechner2]');
    for (var i = 0; i < liste.length; i++) init2(liste[i]);
  }

  function wurzelVon(el) {
    return el && el.closest ? el.closest('[data-mv-rechner2]') : null;
  }

  function beiEingabe2(event) {
    var ziel = event.target;
    if (!ziel || !ziel.closest || !ziel.closest('[data-mv-rechner2-feld], [data-mv-rechner2-miete], [data-mv-rechner2-ust]')) return;
    var root = wurzelVon(ziel);
    if (!root) return;
    /* Zahlenfelder: beim Verlassen auf min/max begrenzen und den Wert so stehen lassen */
    if (event.type === 'change' && ziel.type === 'number' && ziel.hasAttribute('data-mv-rechner2-feld')) {
      var n = lies(root, ziel.getAttribute('data-mv-rechner2-feld'));
      if (isFinite(n) && String(n) !== ziel.value) ziel.value = String(n);
    }
    aktualisiere2(root, { animieren: true, ansage: true });
  }

  function beiKlick(event) {
    var ziel = event.target;
    if (!ziel || !ziel.closest) return;
    var reiter = ziel.closest('[data-mv-rechner2-reiter]');
    if (reiter) {
      waehleReiter(wurzelVon(reiter), reiter);
      return;
    }
    var zurueck = ziel.closest('[data-mv-rechner2-zuruecksetzen]');
    if (zurueck) zuruecksetzen(wurzelVon(zurueck));
  }

  /* Pfeil links/rechts, Pos1, Ende in der Reiterleiste (automatische Aktivierung) */
  function beiTaste(event) {
    var ziel = event.target;
    var reiter = ziel && ziel.closest ? ziel.closest('[data-mv-rechner2-reiter]') : null;
    if (!reiter) return;
    var root = wurzelVon(reiter);
    if (!root) return;
    var alle = Array.prototype.slice.call(root.querySelectorAll('[data-mv-rechner2-reiter]'));
    var i = alle.indexOf(reiter);
    var neu = null;
    if (event.key === 'ArrowRight') neu = alle[(i + 1) % alle.length];
    else if (event.key === 'ArrowLeft') neu = alle[(i - 1 + alle.length) % alle.length];
    else if (event.key === 'Home') neu = alle[0];
    else if (event.key === 'End') neu = alle[alle.length - 1];
    if (!neu) return;
    event.preventDefault();
    waehleReiter(root, neu);
    neu.focus();
  }

  /* ------------------------------------------------------------------ Ereignisse */

  document.addEventListener('input', beiEingabe);
  document.addEventListener('change', beiEingabe);
  document.addEventListener('input', beiEingabe2);
  document.addEventListener('change', beiEingabe2);
  document.addEventListener('click', beiKlick);
  document.addEventListener('keydown', beiTaste);

  /* Impact: variant:change (bubbles, detail.variant.price in Cent) - Geraetepreis netto der Variante */
  document.addEventListener('variant:change', function (event) {
    var variante = event && event.detail && event.detail.variant;
    if (!variante || variante.id === undefined || variante.id === null) return;
    var id = String(variante.id);
    var liste = document.querySelectorAll('[data-mv-rechner2][data-mv-rechner2-varianten]');
    for (var i = 0; i < liste.length; i++) {
      var root = liste[i];
      var ids = (root.getAttribute('data-mv-rechner2-varianten') || '').split(',');
      if (ids.indexOf(id) === -1) continue;
      if (typeof variante.price === 'number' && variante.price > 0) {
        root.setAttribute('data-mv-rechner2-geraet', String(Math.floor(variante.price / 100)));
      }
      aktualisiere2(root, { animieren: true, ansage: false });
    }
  });

  /* Theme-Editor laedt Sektionen einzeln neu; Zurueck-Navigation stellt Eingaben wieder her */
  document.addEventListener('shopify:section:load', function (event) {
    alleAktualisieren(event.target);
    alle2(event.target);
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    alleAktualisieren(document);
    alle2(document);
  });

  function start() {
    alleAktualisieren(document);
    alle2(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
